define.alias("shared/services/shared/popup-manager", "preview-grid/services/shared/popup-manager");